<template>
  <div class="footer-container">
    <ul>
      <li>版权©️海南会多多信息技术有限公司</li>
      <li>琼ICP备2021004082号-1</li>
      <!-- <li>公司地址：海南省海口市龙华区南沙路47号通信广场二K007</li> -->
    </ul>
  </div>
</template>
<script>
export default {
  name: 'homeFooter',
  props: {},
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {}
}
</script>
<style scoped >
 .footer-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 9.85vh;
    background: #23252B;
    padding: 5px 0 10px;
    box-sizing: border-box;
  }
  .footer-container ul {
    width: fit-content;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #9E9E9E;
    cursor: pointer;
    text-wrap: nowrap;
  }
  .footer-container ul li{
    display: inline-block;
    margin-right: 40px;
  }
@media screen and (max-width: 768px) {
  .footer-container {
    height: 9vh;
    padding: 5px 0 10px;
  }
  .footer-container ul {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    font-size: 12px;
  }
  .footer-container ul li{
    margin-top: 5px;
  }
}

@media screen and (min-width: 768px) {
  .footer-container {
    height: 5vh;
  }
  .footer-container ul {
    display: flex;
    align-items: center;
    height: 50px;
  }
  .footer-container ul li{
    display: inline-block;
    margin-right: 40px;
  }
}
</style>